import React, { useCallback, useMemo, useState } from 'react';
import ProUpgradeContext from './ProUpgradeContext';
import ProUpgradeDialog from '../components/billing/ProUpgradeDialog';
import useCheckoutLauncher from '../hooks/useCheckoutLauncher';
import useStorePlan from '../hooks/useStorePlan';

export const ProUpgradeProvider = ({ storeId, isOwner = false, children }) => {
  const { isPro, entitlements } = useStorePlan(storeId, Boolean(storeId));
  const { startCheckout, loading: checkoutLoading } = useCheckoutLauncher(storeId);
  const [open, setOpen] = useState(false);
  const isLapsed = Boolean(entitlements?.isLapsedPro);

  const openProUpgrade = useCallback(() => {
    if (isPro) {
      return;
    }
    setOpen(true);
  }, [isPro]);

  const handleStartPro = useCallback(async () => {
    await startCheckout();
  }, [startCheckout]);

  const value = useMemo(() => ({
    isPro,
    isOwner,
    openProUpgrade,
  }), [isOwner, isPro, openProUpgrade]);

  return (
    <ProUpgradeContext.Provider value={value}>
      {children}
      <ProUpgradeDialog
        open={open}
        onClose={() => setOpen(false)}
        onStartPro={isOwner ? handleStartPro : null}
        checkoutLoading={checkoutLoading}
        isLapsed={isLapsed}
        isOwner={isOwner}
      />
    </ProUpgradeContext.Provider>
  );
};

export default ProUpgradeProvider;
